import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  sidebarOpen: true,
  theme: 'light',
  loadingOverlay: false,
  toast: {
    open: false,
    message: '',
    type: 'info',
  },
  modal: {
    open: false,
    title: '',
    component: null,
  },
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebarOpen: (state, action) => {
      state.sidebarOpen = action.payload;
    },
    setTheme: (state, action) => {
      state.theme = action.payload;
      localStorage.setItem('theme', action.payload);
    },
    showLoadingOverlay: (state) => {
      state.loadingOverlay = true;
    },
    hideLoadingOverlay: (state) => {
      state.loadingOverlay = false;
    },
    showToast: (state, action) => {
      state.toast = {
        open: true,
        message: action.payload.message,
        type: action.payload.type || 'info',
      };
    },
    hideToast: (state) => {
      state.toast.open = false;
    },
    openModal: (state, action) => {
      state.modal = {
        open: true,
        title: action.payload.title || '',
        component: action.payload.component || null,
      };
    },
    closeModal: (state) => {
      state.modal.open = false;
      state.modal.component = null;
    },
  },
});

export const {
  toggleSidebar,
  setSidebarOpen,
  setTheme,
  showLoadingOverlay,
  hideLoadingOverlay,
  showToast,
  hideToast,
  openModal,
  closeModal,
} = uiSlice.actions;

export default uiSlice.reducer;